<script>
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import moment from "moment";
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "YMCStartup","StrBirimHarcamaLimitTutari"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      Malzemeler: {},
      MalzemeSayisi: 0,
      Fiyatlar: [],
      FiyatSayisi: 0,
      FiyatlarArray: [],
      Yaklasikmaliyetgorevliler: "",
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      Dosyaadi: "",
      TableData: {},
      Firmalar: {},
      Malzeme: {},
      IhaleUsuluKod: {},
      okurumsabit: {},
      ihaleyiyapanmakam: "",
      Dosya: null,
      GetBirimButceTutari: null,
      Alimturukod: null,
      sumMaliyetBedel: null,
      GununTarihi: moment(String(new Date())).format("DD.MM.YYYY"),
      UygunGorulenFirmalarData: {},
      MinMaliyet: 0
    };
  },
  components: {
    VueQRCodeComponent
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
    YMCStartup() {
      this.Get();
    }
  },
  methods: {
    Get() {

      this.ActionsGet({
        Service: "okurumsabit",
        Page: this.Page
      }).then((res) => {
        this.okurumsabit = res.Data[0];
      });


      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        if (res && Object.keys(res.Data).length > 0) {
          this.Dosya = res.Data

          this.Dosyaadi = res.Data.Dosyaadi
          this.Yaklasikmaliyetgorevliler = res.Data.Yaklasikmaliyetgorevliler;
          this.ActionsGet({ "Service": "Obirim/" + res.Data.Ihaleyiyapanmakam, "Page": this.Page }).then((res2) => {
            this.ihaleyiyapanmakam = res2.Data.BirimAdi;
            this.ActionsSingleGet({
        Service: "okeyvalues",
        Id: this.Dosya.Ihaleturu,
      }).then((res) => {
          this.IhaleUsuluKod = res.Data.Kod

            

          });

          });

          this.ActionsFilterGet({
            Service: "StrBirimKontrolTutarlari/GetBirimButce",
            Page: this.Page,
            Filter: "&Donem=" + moment(String(res.Data.Dosyaacilistarih)).format("YYYY")
              + "&Birimid=" + res.Data.Ihaleyiyapanmakam
          }).then((GetBirimButce) => {
            if (GetBirimButce) {
              this.ActionsSabitGet(1548).then(keyvalues => {
                this.Alimturukod = 0
                for (var j = 0; j < keyvalues.Data.length; j++) {
                  if (keyvalues.Data[j].Id == res.Data.Alimturu) {
                    this.Alimturukod = keyvalues.Data[j].Kod
                  }
                }
                this.GetBirimButceTutari = 0
                for (let i = 0; i < Object.keys(GetBirimButce.Data).length; i++) {
                  if (this.Alimturukod == 1) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].tmal -
                      GetBirimButce.Data[i].thmal22d -
                      GetBirimButce.Data[i].thmal21f
                    ).toFixed(2)
                  }

                  if (this.Alimturukod == 2) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].thizmet -
                      GetBirimButce.Data[i].thhizmet22d -
                      GetBirimButce.Data[i].thhizmet21f
                    ).toFixed(2)
                  }
                  if (this.Alimturukod == 3) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].tyapim -
                      GetBirimButce.Data[i].thyapim22d -
                      GetBirimButce.Data[i].thyapim21f
                    ).toFixed(2)
                  }

                }

              });

            }
          });

        }

      });
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        if(res.Data.yaklasikmaaliyetbirimfiyat == false){
          this.ActionsFilterGet({
        Service: "satdosyafirmafiyat/getgiris",
        Page: this.Page,
        Filter:
          "&Dosyaid=" +
          this.satdosyaId +
          "&Asc=Sirano&Fiyatturu=1",
      }).then((res) => {
        this.TableData = res.Data
        this.Firmalar = this.groupBy(res.Data, "Dosyafirmaid");
        this.Malzeme = this.groupBy(res.Data, "Dosyamalzemeid");
        this.FiyatSayisi = Object.keys(this.Firmalar).length

      });
        }else{
          this.ActionsFilterGet({
        Service: "satdosyafirmafiyat/getgiris",
        Page: this.Page,
        Filter:
          "&Dosyaid=" +
          this.satdosyaId +
          "&Asc=Sirano&Fiyatturu=4&IsFiyatTuruNull=false",
      }).then((res) => {
        this.TableData = res.Data
        this.Firmalar = this.groupBy(res.Data, "Dosyafirmaid");
        this.Malzeme = this.groupBy(res.Data, "Dosyamalzemeid");
        this.FiyatSayisi = Object.keys(this.Firmalar).length

      });
        }
    });
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.PiyasaArastirmaTutanagi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var a = document.createElement('a');
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + '.xls';
      a.click();
    },
    OrtalamaBirimFiyati(MalzemId) {
      var OrtalamaFiyat = 0;
      var Birimfiyat = 0;
      var FiyatOlmayan = 0;
      for (let i = 0; i < this.Malzeme.[MalzemId].length; i++) {
        Birimfiyat = this.Malzeme.[MalzemId][i].Birimfiyat;
        if (Birimfiyat != null) OrtalamaFiyat += Birimfiyat
        else FiyatOlmayan += 1
      }
      return (OrtalamaFiyat / (this.FiyatSayisi - FiyatOlmayan)).toFixed(2);
    },
    ToplamMaliyetBedeli(MalzemId, Adet) {
      var OrtalamaFiyat = 0;
      var Birimfiyat = 0;
      var FiyatOlmayan = 0;
      for (let i = 0; i < this.Malzeme.[MalzemId].length; i++) {
        Birimfiyat = this.Malzeme.[MalzemId][i].Birimfiyat;
        if (Birimfiyat != null) OrtalamaFiyat += Birimfiyat
        else FiyatOlmayan += 1
      }
      return ((OrtalamaFiyat / (this.FiyatSayisi - FiyatOlmayan)).toFixed(2) * Adet).toFixed(2);
    },
    ToplamMaliyetBedeliTotal() {
      var Total = 0;
      let Malzemeler = this.Malzeme;
      for (let Malzeme in Malzemeler) {

        var FiyatOrtalama = 0;
        var FiyatOlmayan = 0;
        for (let j = 0; j < Malzemeler[Malzeme].length; j++) {
          FiyatOrtalama += Malzemeler[Malzeme][j].Birimfiyat;
          if (Malzemeler[Malzeme][j].Birimfiyat == null) FiyatOlmayan += 1
        }
        FiyatOrtalama = FiyatOrtalama / (this.FiyatSayisi - FiyatOlmayan);
        FiyatOrtalama = FiyatOrtalama.toFixed(2)

        Total += FiyatOrtalama * Malzemeler[Malzeme][0].Adet;

      }
      return Total.toFixed(2);
    },
    Export2Word(element, filename) {
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html = preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      });

      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + '.doc' : 'document.doc';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },

  },
};
</script>


<template>
  <b-modal id="yaklasikmaliyetcetveli" size="xl" scrollable :title="$t('satdosyayaklasikmaliyetcetveli.Title')"
    title-class="font-18" hide-footer>
    <div class="row">
 
      
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4"></div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                      'Yaklaşık Maliyet Cetveli',
                      'Yaklaşık Maliyet Cetveli'
                    )
                  ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    {{
                      $t("satdosyayaklasikmaliyetcetveli.Page.ExceleAktar")
                    }}
                  </button>
                  <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" @click="
                    Export2Word(
                      'exportContent',
                      'Yaklaşık Maliyet Cetveli'
                    )
                  ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Word'e Aktar
                  </button>
                </div>
              </div>
            </div>

            <div id="exportContent">
              <div class="table-responsive" ref="PiyasaArastirmaTutanagi">
                <table class="table table-borderless mb-0">
                  <thead>
                    <tr>
                      <th :colspan="2" class="text-sm-center" style="font-size: 12px">
                        YAKLAŞIK MALİYET HESAP CETVELİ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row" style="text-align: left; font-size: 12px">
                        İDARENİN ADI : {{ ihaleyiyapanmakam }}
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="2" scope="row" style="text-align: left; font-size: 12px">
                        İŞİN ADI : {{ Dosyaadi }}
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="2" scope="row" style="text-align: left; font-size: 12px">
                        DÜZENLENME TARİHİ: {{ new Date() | formatDateTable }}
                      </th>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                      <td :colspan="2">
                        <table class="table table-bordered mb-0" style="border-collapse: collapse;">
                          <tbody>
                            <tr>
                              <th style="border: 1px solid; font-size: 10px"></th>
                              <th style="border: 1px solid;  width: 5px; font-size: 10px" colspan="2">FİRMA ADI ADRESİ
                              </th>
                              <th style="border: 1px solid; font-size: 10px" v-for="(Firma, index) in Firmalar"
                                :key="index">
                                {{ Firma[0].Firmaadi }}
                              </th>
                              <th style="border: 1px solid;"></th>
                              <th style="border: 1px solid;"></th>
                            </tr>
                            <tr>
                              <th style="border: 1px solid; font-size: 10px">Mal / Hizmetin Adı</th>
                              <th style="border: 1px solid; font-size: 10px">Mal / Hizmetin Miktarı</th>
                              <th style="border: 1px solid; font-size: 10px">Ölçü Birimi</th>
                              <th style="border: 1px solid; font-size: 10px" v-for="(Firma, index) in Firmalar"
                                :key="index">
                                Mal/Hizmet Birim Fiyat Teklifi
                              </th>
                              <th style="border: 1px solid; font-size: 10px">Ortalama Birim Fiyat</th>
                              <th style="border: 1px solid; font-size: 10px">Toplam Maliyet Bedeli</th>
                            </tr>

                            <tr v-for="(Malzeme, index) in Malzeme" :key="index">
                              <td style="border: 1px solid; font-size: 10px">{{ Malzeme[0].Malzemeadi }}</td>
                              <td style="border: 1px solid; text-align: center; font-size: 10px">{{ Malzeme[0].Adet }}
                              </td>
                              <td style="border: 1px solid; text-align: center; font-size: 10px">{{
                                Malzeme[0].Olcubirimi }}</td>
                              <td style="text-align: center;border: 1px solid; font-size: 10px"
                                v-for="(Firma, index) in Firmalar" :key="index">
                                {{
                                  Firma.filter((notification) =>
                                    notification.Dosyamalzemeid.includes(
                                      Malzeme[0].Dosyamalzemeid
                                    )
                                  )[0].Birimfiyat | TrParaFormat
                                }}
                              </td>

                              <td style="text-align: center; border: 1px solid; font-size: 10px">
                                {{
                                  OrtalamaBirimFiyati(
                                    Malzeme[0].Dosyamalzemeid
                                  ) | TrParaFormat
                                }}
                              </td>
                              <td style="text-align: center; border: 1px solid; font-size: 10px">
                                {{
                                  ToplamMaliyetBedeli(
                                    Malzeme[0].Dosyamalzemeid,
                                    Malzeme[0].Adet
                                  ) | TrParaFormat
                                }}
                              </td>
                            </tr> 
                            <tr><td> 
                            </td></tr>
             <!--              <tr style="--bs-table-accent-bg: red; color: white;">
                              <td :colspan="5 + FiyatSayisi" style="  border: 1px solid; font-size: 10px"
                                v-if="okurumsabit.Dogrudanteminlimiti < ToplamMaliyetBedeliTotal() && Dosya.Butcedisi != true">
                                <b> ! Doğrudan temin limitiniz {{ okurumsabit.Dogrudanteminlimiti | TrParaFormat }} ₺.
                                  Yaklaşık maliyet tutarınız bu tutarı geçmektedir.</b>
                              </td>
                            </tr> --> 
                            <tr style="--bs-table-accent-bg: red; color: white;">
                              <td :colspan="5 + FiyatSayisi" style="  border: 1px solid; font-size: 10px"
                                v-if="this.StrBirimHarcamaLimitTutari.YuzdeOnLimit != null && Dosya.Butcedisi != true">
                                <b> t{{his.StrBirimHarcamaLimitTutari.YuzdeOnLimit}}</b>
                              </td>
                            </tr>
                            <tr style="--bs-table-accent-bg: red; color: white;">
                              <td :colspan="5 + FiyatSayisi" style="  border: 1px solid; font-size: 10px"
                                v-if="this.StrBirimHarcamaLimitTutari.UstLimit != null  && Dosya.Butcedisi != true">
                                <b> ! {{this.StrBirimHarcamaLimitTutari.UstLimit}}
                                  </b>
                              </td>
                            </tr>
                            <tr>
                              <td :colspan="4 + FiyatSayisi"
                                style="text-align: right; border: 1px solid; font-size: 10px">
                                <b>Toplam:</b>
                              </td>
                              <td style="text-align: center; border: 1px solid; font-size: 10px">
                                {{
                                  ToplamMaliyetBedeliTotal() | TrParaFormat
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr v-if="Yaklasikmaliyetgorevliler != null">
                      <td :colspan="2"></td>
                    </tr>
                    <tr v-if="Yaklasikmaliyetgorevliler != null">
                      <td colspan="2">
                        <table class="table table-borderless mb-0" style=" border-collapse: collapse; width:100%">
                          <thead>
                            <tr>
                              <th :colspan="Yaklasikmaliyetgorevliler.length * 2"
                                style="text-align: left; border: 1px solid; font-size: 10px">
                                Belgeyi Düzenleyenler;
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="border: 1px solid; font-size: 10px" colspan="2" v-for="(
                                              Gorevliler, index
                                            ) in Yaklasikmaliyetgorevliler" :key="index">
                                <b>Adı Soyadı:</b> {{ Gorevliler.AdSoyad }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid; font-size: 10px" colspan="2" v-for="(
                                              Gorevliler, index
                                            ) in Yaklasikmaliyetgorevliler" :key="index">
                                <b>Ünvanı:</b> {{ Gorevliler.Unvan }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid; font-size: 10px" colspan="2" v-for="(
                                              Gorevliler, index
                                            ) in Yaklasikmaliyetgorevliler" :key="index">
                                <b>İmzası:</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td :colspan="2"></td>
                    </tr>
                    <tr>
                      <th style="text-align: left; font-size: 10px">
                        EK: {{ FiyatSayisi }} Adet firma teklifi
                      </th>
                    </tr>
                  </tbody>
                </table> 
                <VueQRCodeComponent  style=" float: right;"
                size="100"
                :text='"İşin Adı: "+Dosyaadi+"  DÜZENLENME TARİHİ:"+GununTarihi+" Oluşturan Kullanıcı:"+UserNameSurName' /> 
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

